import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import CmsPageForm from '@/modules/cms_page/components/CmsPageForm.vue';
import { CmsPage } from '@/modules/cms_page/CmsPage';


export default /*@__PURE__*/_defineComponent({
  __name: 'CmsPageCreate',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const cmsPage = ref<Partial<CmsPage>>({
	user_type: [],
	content: [],
});

const saved = (cmsPage) => {
	Flash.success($gettext('CMS-sida tillagd'));
	router.push({
		name: 'cmsPage.edit',
		params: { id: cmsPage.id },
	});
};

const cancel = () => {
	router.push({ name: 'cmsPage.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CmsPageForm, {
    "page-title": _unref($gettext)('Ny CMS-sida'),
    "cms-page": cmsPage.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "cms-page"]))
}
}

})